var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumpJack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.969,14.148c-1.128-.608-1.023-2.235.18-2.688l4.859-1.736c.082-.055.088-.237.123-.333.71-1.959,2.883-2.593,4.556-1.352l2.561-.914.027-.053-.483-3.406c.005-.268.152-.531.392-.652.187-.095,1.337-.511,1.498-.512.162-.001.346.068.47.173.756,1.224,1.587,2.433,2.283,3.696.322.585.445,1.011.554,1.671.189,1.148.382,2.411.511,3.564.1.894-.107.917-.856,1.202-.517.197-1.179.563-1.581.002-.579-.807-1.059-1.81-1.608-2.655-.03-.046-.166-.269-.201-.273l-2.576.929c-.096.223-.15.463-.257.682-.095.194-.244.368-.333.556l3.799,8.035c.152-.018.322.031.464.032,1.125.012,2.256-.059,3.378,0,.251.013.391-.036.632.092.249.133.407.387.429.67.057.733.072,1.545-.846,1.623H3.07c-.337-.024-.65-.17-.795-.49-.112-.247-.116-1.144-.015-1.393.225-.555.761-.511,1.266-.53.132-.005.272-.008.401.025l.042-.037v-5.925ZM12.909,10.232c0-.581-.471-1.051-1.051-1.051s-1.051.471-1.051,1.051.471,1.051,1.051,1.051,1.051-.471,1.051-1.051ZM5.31,14.175v5.911l.51.013.049-.058,3.436-7.287-3.995,1.421ZM8.554,20.086l6.622-.014-3.311-6.956-3.311,6.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpJack);
export default __webpack_public_path__ + "static/media/PumpJack.16111ede1959876d0a586b1903cfaf45.svg";
export { ForwardRef as ReactComponent };